<script setup lang="ts">
import { ref } from 'vue';
import VSkeleton from '@shared/component/VSkeleton/VSkeleton.vue';
import VSearch from '@shared/component/VSearch/VSearch.vue';
import { useWatchErrorHandler } from '@errors/useErrorHandler';
import { useMedewerkersGetContactpaginaMedewerkers } from '@services/crm-public/orval-api/medewerkers-api/medewerkers-api';
import { useContactpaginaSearch } from '../contactpagina';
import ContactBedrijfsinformatie from '../components/ContactBedrijfsinformatie.vue';
import ContactMedewerkerCard from '../components/ContactMedewerkerCard.vue';
import ContactKlankbordVerzoek from '../components/ContactKlankbordVerzoek.vue';
import ContactAfdelingHeader from '../components/ContactAfdelingHeader.vue';

const { data, error, isPending } = useMedewerkersGetContactpaginaMedewerkers({
  query: { select: (res) => res.result },
});

useWatchErrorHandler(error);

const searchQuery = ref('');

const { gefilterdeData, isZichtbaar } = useContactpaginaSearch(data, searchQuery);
</script>

<template>
  <div>
    <template v-if="isPending">
      <div class="space-y-8">
        <VSkeleton height="lg" />
        <div class="grid grid-cols-[repeat(auto-fill,_minmax(260px,_1fr))] gap-4">
          <VSkeleton v-for="i in 12" :key="i" height="xl" />
        </div>
      </div>
    </template>

    <div class="space-y-8" v-if="!isPending && gefilterdeData">
      <ContactBedrijfsinformatie :accountmanager="gefilterdeData?.accountmanager" />

      <VSearch v-model="searchQuery" placeholder="Zoek medewerker..." class="w-full max-w-xs" />

      <div
        v-for="afdeling in gefilterdeData?.afdelingen"
        :key="afdeling.afdelingId"
        v-show="afdeling.medewerkers.some((m) => isZichtbaar(m))"
      >
        <ContactAfdelingHeader
          :omschrijving="afdeling.omschrijving"
          :telefoonnummer="afdeling.telefoonnummer"
          :email="afdeling.email"
        />

        <div class="grid grid-cols-[repeat(auto-fill,_minmax(260px,_1fr))] gap-4">
          <ContactKlankbordVerzoek v-if="afdeling.afdelingId === 22" />

          <ContactMedewerkerCard
            v-for="gebruiker in afdeling.medewerkers"
            v-show="isZichtbaar(gebruiker)"
            :key="gebruiker.gebruikerId ?? gebruiker.volledigeNaam"
            :gebruiker="gebruiker"
          />
        </div>
      </div>

      <p
        v-if="
          searchQuery &&
          gefilterdeData?.afdelingen.every((afdeling) =>
            afdeling.medewerkers.every((m) => !isZichtbaar(m)),
          )
        "
        class="mt-6 text-center text-grey-500"
      >
        Geen medewerkers gevonden voor "{{ searchQuery }}"
      </p>
    </div>
  </div>
</template>
